export default __webpack_public_path__ + "static/media/Cane2Sugar_03.4d79ab75.png";